import * as React from 'react';
import { LogbogIndlaeg } from '../../models/LogbogIndlaeg';
import Moment from 'react-moment';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { Icon } from '../../uiComponents/Icon';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Bruger } from '../../models/Bruger';

export interface LogbogDialogIndlaegProps {
    logbogIndlaeg: LogbogIndlaeg;
    updateIndlaeg: any;
}

interface LogbogDialogIndlaegState {
    isSubmitting: boolean;
    editable: boolean;
    tekst: string;
}

export default class LogbogDialogIndlaeg extends React.Component<LogbogDialogIndlaegProps, LogbogDialogIndlaegState> {
    constructor(props: LogbogDialogIndlaegProps) {
        super(props);
        this.state = {
            isSubmitting: false,
            editable: false,
            tekst: this.props.logbogIndlaeg.tekst
        };
    }

    getBrugerNavn(bruger: Bruger) {
        if (bruger.navn !== null) {
            return bruger.navn + ' (' + bruger.brugernavn + ')';
        } else{
            return bruger.brugernavn;
        }        
    }

    getHeader = (indlaeg: LogbogIndlaeg) => {
        if (indlaeg.bruger.rolle === BrugerRolleEnum.Elev) {
            return <h1>{this.getBrugerNavn(indlaeg.bruger)}, <Moment format='DD.MM.YY'>{indlaeg.createdDate.toString()}</Moment></h1>;
        }

        return (
            <div>
                <div className='laerer-icon'>
                    <Icon name='user' />
                </div>
                <div className='laerer-header'>
                    <h1>{indlaeg.bruger.navn}</h1>
                    <h2>
                        <Moment format='DD.MM.YY'>{indlaeg.createdDate.toString()}</Moment>
                    </h2>
                </div>
            </div>
        );
    }

    toggleEditable = () => {
        if (this.state.editable) {
            this.setState({ editable: !this.state.editable, tekst: this.props.logbogIndlaeg.tekst });
        } else {
            this.setState({ editable: !this.state.editable });
        }
    }

    getEditIcon() {
        if (this.props.logbogIndlaeg.brugerId === getLoggedInBruger().id) {
            let iconName = 'edit';
            if (this.state.editable) {
                iconName = 'close';
            }
            return (
                <div className='logbog-indlaeg-edit-wrapper' onClick={this.toggleEditable}>
                    <Icon name={iconName} />
                </div>
            );
        }

        return '';
    }

    getDisabled() {
        return this.state.isSubmitting;
    }

    onTekstChanged = (e: any) => {
        this.setState({ tekst: e.target.value });
    }

    getText() {

        if (this.state.editable) {
            return (
                <textarea
                    className='form-control logbog-dialog-indlaeg-textarea'
                    onChange={this.onTekstChanged}
                    placeholder='Skriv svar'
                    value={this.state.tekst}
                    autoFocus={true}
                    disabled={this.getDisabled()}
                />
            );
        }

        const tekstElements = this.state.tekst.split('\n').map((b, i) =>
            (
                <span key={i}>
                    {b}
                    <br />
                </span>
            )
        );

        return <div className='tekst'>{tekstElements}</div>;
    }

    updateLogbogIndlaeg = () => {
        this.setState({ isSubmitting: true });

        let indlaeg = this.props.logbogIndlaeg;
        indlaeg.tekst = this.state.tekst;
        this.props.updateIndlaeg(indlaeg).
            then(() => {
                this.setState({ isSubmitting: false, editable: false });
            });
    }

    getSubmitButton = () => {
        if (this.state.editable) {
            return (
                <Button className='logbog-indlaeg-component-button' buttonType='primary' buttonSize='md' onClick={this.updateLogbogIndlaeg} disabled={this.getDisabled()}>
                    Gem svar
                </Button>
            );
        }

        return undefined;
    }

    render() {
        let className = 'logbog-dialog-indlaeg';
        if (this.props.logbogIndlaeg.bruger.rolle === BrugerRolleEnum.Laerer) {
            className += ' laerer-indlaeg';
        }
        return (
            <div>
                <div className={className}>
                    {this.getEditIcon()}
                    {this.getHeader(this.props.logbogIndlaeg)}
                    {this.getText()}
                    {this.getSubmitButton()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/LogbogDialogIndlaeg.tsx